<template>
  <div v-if="!isAddPatient" class="hospital-container container">
    <span class="basic-title">入院急救：</span>
    <div class="detail-info hospital-info">
      <span class="info-key">操作：</span>
      <!-- 展示页面 -->
      <span v-if="isShowPatient" class="info-item">
        {{
          checkForm.operation
        }}
      </span>
      <!-- 补写页面 -->
      <el-input
        v-else-if="isWriteMore"
        v-model="checkForm.operation"
        class="operationInput"
        placeholder=""
        type="textarea"
        resize="none"
        :rows="6"
      />
    </div>
    <div class="detail-info check-info substance long-number-line">
      <span class="info-title">门诊/住院号:：</span>
      <div v-if="isShowPatient" style="display: inline-block">
        {{ checkForm.outpatient_number }}
      </div>
      <el-input
        v-else
        v-model="checkForm.outpatient_number"
        class="diagnosed"
        placeholder=""
      />
    </div>
    <div class="detail-info check-info substance after-result">
      <span class="info-title">后续结果：</span>
      <div v-if="isShowPatient" style="display: inline-block">
        <!-- 展示页面,不能做任何修改 -->
        <el-radio
          v-model="checkForm.result"
          label="出院"
          :disabled="isShowPatient"
        >出院
        </el-radio>
        <el-radio
          v-model="checkForm.result"
          label="留院观察"
          :disabled="isShowPatient"
        >留院观察
        </el-radio>
        <el-radio
          v-model="checkForm.result"
          label="转住院区"
          :disabled="isShowPatient"
        >转住院区
        </el-radio>

        <el-radio
          v-model="checkForm.result"
          label="重症监护"
          :disabled="isShowPatient"
        >重症监护
        </el-radio>
        <el-radio
          v-model="checkForm.result"
          label="死亡"
          :disabled="isShowPatient"
        >死亡
        </el-radio>
      </div>

      <div v-else style="display: inline-block">
        <!-- 编辑页面,可以修改 -->
        <el-radio
          v-model="checkForm.result"
          label="出院"
        >出院
        </el-radio>
        <el-radio
          v-model="checkForm.result"
          label="留院观察"
        > 留院观察
        </el-radio>
        <el-radio
          v-model="checkForm.result"
          label="转住院区"
        > 转住院区
        </el-radio>
        <el-radio
          v-model="checkForm.result"
          label="重症监护"
        > 重症监护
        </el-radio>
        <el-radio
          v-model="checkForm.result"
          label="死亡"
        >死亡
        </el-radio>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  name: "HospitalEmergency",
  data() {
    return {
      checkForm: {
        result: "", operation: "", outpatient_number: ""
      }
    };
  },
  computed: {
    ...mapState({
      patient: "showOrEditPatientInfo"
    }),
    isShowPatient() {
      return this.patient?.pageInfo?.isShowPatient;
    },

    isAddPatient() {
      return this.patient?.pageInfo?.isAddPatient;
    },
    isWriteMore() {
      return this.patient?.pageInfo?.isWriteMore;
    },
  },
  watch: {
    patient: {
      handler(val) {
        const item = val?.inhospitalmedicals;
        if (item.length) {
          const {
            result, operate, outpatient_number
          } = item[0];
          this.checkForm = {
            result, operation: operate, outpatient_number
          };
        }
      },
      immediate: true
    }
  },
};
</script>
<style lang="scss" scoped>
.after-result {
  //padding-top: 10px;

  .info-title {
    width: 108px;
  }
}

.hospital-info {
  padding-top: 12px; // 分区信息标题(已经缩了12px了)
  display: flex;
  align-items: center;
  height: 48px;

  .info-key {
    vertical-align: top;
    line-height: initial;
  }
}

.operationInput {
  width: 800px;
  padding-left: 60px;
}

.long-number-line {
  //padding-top: 20px;

  .info-title {
    width: 110px;
  }

  .diagnosed {
    display: inline-block;
    width: 800px;
  }
}

</style>
